(function () {
  /**
   * @ngdoc module
   * @name akitabox.workOrder.detail
   */
  angular
    .module("akitabox.workOrder.detail")
    .controller("WorkOrderDetailController", WorkOrderDetailController);

  /**
   * @ngdoc controller
   * @module akitabox.workOrder.detail
   *
   * @description
   * Work order detail controller
   *
   * @ngInject
   */
  function WorkOrderDetailController(
    // Angular
    $rootScope,
    $q,
    $log,
    $scope,
    // Third-party
    $state,
    // Libraries
    moment,
    // AkitaBox
    models,
    // Constants
    INTENT_ISSUE_TYPE,
    INTENT_MAINTENANCE_TYPE,
    PRIORITIES,
    // Resolve
    building,
    workOrder,
    // Services
    FeatureFlagService,
    IssueTypeService,
    MaintenanceTypeService,
    NoteService,
    ScheduleService,
    ShadowService,
    TimeZoneService,
    OrganizationService,
    ToastService,
    TradeService,
    TypeService,
    UserService,
    WorkOrderLogService,
    WorkOrderService,
    ServiceHelpers,
    // Dialogs
    WorkOrderLogDialog,
    CancelWorkOrderDialog,
    CompleteWorkOrderDialog,
    ReopenWorkOrderDialog,
    DeleteWorkOrderDialog,
    CreateMessageDialog,
    DisplayTextDialog
  ) {
    var self = this;

    var _permissions = UserService.getPermissions();

    var actionStateParams = {
      buildingId: building._id,
      workOrderId: workOrder._id,
    };

    // Constants
    self.PRIORITIES = PRIORITIES;

    // Attributes
    self.utcOffset = TimeZoneService.getCurrentUTCOffset();
    self.organization = OrganizationService.getCurrent();
    self.building = building;
    self.workOrder = workOrder;
    self.fromInspection = self.workOrder.source === "inspection";
    self.multiLocationEnabled = self.organization.show_inspections;
    self.activeTab = 0;
    self.permissions = getPermissions();
    self.headerActions = getHeaderActions();

    // Types and Trades
    var collection = {
      trades: null,
      types: null,
    };
    var tradeRequest;
    var typeRequest;
    self.loadingTrade = true;
    self.loadingType = true;

    // Details
    self.isOpen = true;
    self.dueDateOpen = false;
    self.completedDateOpen = false;
    self.startDateOpen = false;
    self.editingDates = false;
    self.editingDescription = false;
    self.editingDetails = false;
    self.editingLocation = false;
    self.editingAssign = false;
    self.editingCategory = false;
    self.editingAssignees = false;
    self.editingActualManHr = false;
    self.editingCost = false;
    self.editingMaterialUsed = false;
    self.editingCompletedText = false;
    self.hasLinkedServiceRequest = false;
    self.hasMaintenanceSchedule = false;
    self.canSaveIssueType = false;
    self.canSaveMaintenanceType = false;
    self.today = new Date();
    self.workOrderLogStats = {
      totalLoggedMinutes: 0,
      totalCost: 0,
    };
    self.assignees = [];

    self.calculateWoLogTotals = calculateWoLogTotals;

    // Activity
    self.lastActivityItem = {
      activityType: "created-entity",
      entity: "Work Order",
      time: self.workOrder.created_date,
      cre_account: self.workOrder.created_by,
    };
    self.activityParams = {
      task: self.workOrder._id,
      method: "$in,DELETE,PATCH,POST,PUT",
    };
    self.noteParams = {};
    if (self.workOrder.request) {
      var request = self.workOrder.request._id || self.workOrder.request;
      self.noteParams.$or =
        "task=" + self.workOrder._id + ";request=" + request;
      self.noteParams.task = undefined; // to unset the existing work order query and replace it with the or
    }

    // location
    self.asset;
    self.room;
    self.level;
    self.locationIsDuplicated = false;

    // Functions
    self.getStatusClass = getStatusClass;
    self.goToBuilding = goToBuilding;
    self.goToState = goToState;
    self.save = save;
    self.onCancel = onCancel;
    self.createNote = createNote;
    self.showActivityTab = showActivityTab;
    self.showDetailsTab = showDetailsTab;
    self.updateDates = updateDates;
    self.isEditing = isEditing;
    self.goToServiceRequest = goToServiceRequest;
    self.searchTypes = searchTypes;
    self.searchTrades = searchTrades;
    self.onTypeChange = onTypeChange;
    self.onAssigneesChange = onAssigneesChange;
    self.createNewRequest = createNewRequest;
    self.createNewWorkOrder = createNewWorkOrder;
    self.toggleActionMenu = toggleActionMenu;
    self.showDescription = showDescription;
    self.showSubject = showSubject;
    self.handleAddLocationClick = handleAddLocationClick;
    self.handleRemoveLocationClick = handleRemoveLocationClick;
    self.getScheduleFrequencySummary = ScheduleService.getFrequencySummary;

    init();

    // ------------------------
    //   Private Functions
    // ------------------------

    /**
     * Initalize controller
     */
    function init() {
      /**
       * Seems to be no other solution to actively watch this without setting objectEquality -> true
       * We can wait until they click "Create" to tell them they have duplicate locations, but it seems
       * too late already by that point. Also using $watchCollection here seems to not work with an array
       * of objects, since it only compares the objects inside of an array via shallow comparison
       */
      $scope.$watch(
        "vm.locations",
        function (watchedLocations) {
          if (!watchedLocations || watchedLocations.length <= 1)
            return (self.locationIsDuplicated = false);

          var hasDuplicates = false;
          var duplicateLocations = {};
          for (var i = 0; i < watchedLocations.length; i++) {
            var watchedLocation = watchedLocations[i];
            var watchedAsset = watchedLocation.asset
              ? watchedLocation.asset._id
              : "_";
            var watchedFloor = watchedLocation.floor
              ? watchedLocation.floor._id
              : "_";
            var watchedRoom = watchedLocation.room
              ? watchedLocation.room._id
              : "_";
            var hash = watchedAsset + watchedFloor + watchedRoom;
            if (duplicateLocations[hash]) {
              // if we already have this location, mark it as duplicated

              self.locations[i].duplicated = true;
              hasDuplicates = true;
            } else {
              // otherwise, allow blank locations or add the new unique location
              // to our map for tracking
              if (hash === "___") {
                continue;
              }
              duplicateLocations[hash] = [i];
              self.locations[i].duplicated = false;
            }
          }
          self.locationIsDuplicated = hasDuplicates;
        },
        true
      );

      $scope.$watch("vm.editingLocation", function (isTrue) {
        if (isTrue && self.locations.length < 1) {
          handleAddLocationClick();
        }
      });

      getAssignees(self.workOrder);

      // get total hours and total cost stats
      calculateWoLogTotals();

      // Determine days overdue
      if (self.workOrder.days_until_due < 0) {
        self.workOrder.days_overdue = Math.abs(self.workOrder.days_until_due);
      }

      // Convert dates to Date objects
      self.workOrder.start_date = new Date(self.workOrder.start_date);
      self.workOrder.due_date = new Date(self.workOrder.due_date);

      // Set a minimum date for the datePicker to select the dueDate (dueDate cannot be <= startDate)
      self.workOrder.minDate = self.workOrder.start_date;

      self.asset = WorkOrderService.getAsset(self.workOrder);
      self.room = WorkOrderService.getRoom(self.workOrder);
      self.level = WorkOrderService.getLevel(self.workOrder);

      populateLocationData();

      self.originalWorkOrder = angular.copy(self.workOrder); // copy it now since the object is ready

      // check for type
      var beforeType = angular.copy(self.type);
      self.type = self.workOrder.issue_type || self.workOrder.maintenance_type;
      self.loadingType = false;
      // changes to self.type and self.trade are triggering onTypeChange, even though we don't
      // want them to fire on load
      self.typeFromInit = !angular.equals(beforeType, self.type);

      self.canSaveIssueType = self.workOrder.is_from_request;
      self.canSaveMaintenanceType = self.workOrder.is_from_future_task;
      if (
        !self.workOrder.is_from_request &&
        !self.workOrder.is_from_future_task
      ) {
        self.canSaveIssueType = true;
        self.canSaveMaintenanceType = true;
      }

      // check for trade
      var beforeTrade = angular.copy(self.trade);
      self.trade = self.workOrder.trade;
      self.loadingTrade = false;
      // changes to self.type and self.trade are triggering onTypeChange, even though we don't
      // want them to fire on load
      self.tradeFromInit = !angular.equals(beforeTrade, self.trade);

      // check for a linked service request
      if (self.workOrder.request) {
        self.hasLinkedServiceRequest = true;
      }

      // check for a maintenance schedule
      if (self.workOrder.future_task) {
        self.hasMaintenanceSchedule = true;
      }

      self.showIssueTypes =
        !self.hasMaintenanceSchedule && self.building.show_issue_types;
      self.showMaintenanceTypes =
        !self.hasLinkedServiceRequest && self.building.show_maintenance_types;
      self.showType = self.showIssueTypes || self.showMaintenanceTypes;
    }

    function showDescription() {
      DisplayTextDialog.show({
        locals: {
          title: "Description",
          displayText: self.workOrder.description_text,
        },
      });
    }

    function showSubject() {
      DisplayTextDialog.show({
        locals: {
          title: "Subject",
          displayText: self.workOrder.subject,
        },
      });
    }

    function createNewRequest() {
      $state.go("app.serviceRequests.create", {
        building: self.building._id,
      });
    }

    function createNewWorkOrder() {
      $state.go("app.workOrders.create", {
        building: self.building._id,
      });
    }

    function getPermissions() {
      var isScheduled = self.workOrder.is_scheduled;
      var isOpen =
        isScheduled || self.workOrder.is_open || self.workOrder.is_overdue;
      var isClosed = self.workOrder.is_completed || self.workOrder.is_canceled;

      var currentUser = UserService.getCurrent();
      var assignees = self.workOrder.assignee_users.map(function (assignee) {
        if (assignee._id) return assignee._id;
        return assignee;
      });
      var isAssigned = assignees.indexOf(currentUser._id) > -1;
      return {
        canUpdate: _permissions.task.update,
        canAssign: _permissions.task.assign,
        canCancel: _permissions.task.cancel && isOpen,
        canComplete: (_permissions.task.complete_any || isAssigned) && isOpen,
        canReopen: _permissions.task.reopen && isClosed,
        canDelete: _permissions.task.remove && isClosed,
        canLogWork:
          _permissions.work_order_log.create_any ||
          _permissions.work_order_log.create_own_log_on_any_task ||
          isAssigned,
      };
    }

    function getHeaderActions() {
      var actions = [];

      if (
        self.permissions.canComplete &&
        !self.workOrder.is_scheduled &&
        !self.fromInspection
      ) {
        actions.push({
          label: "Complete",
          icon: "check",
          action: complete,
        });
      }
      if (self.permissions.canCancel) {
        actions.push({
          label: "Cancel",
          icon: "close",
          action: cancel,
        });
      }
      if (self.permissions.canReopen) {
        actions.push({
          label: "Reopen",
          icon: "restore",
          action: reopen,
        });
      }
      if (self.permissions.canDelete) {
        actions.push({
          label: "Delete",
          icon: "delete",
          action: remove,
        });
      }

      if (self.permissions.canLogWork) {
        actions.push({
          label: "Log Work",
          icon: "access_time",
          action: logWork,
        });
      }

      actions.push({
        label: "Add Message",
        icon: "message",
        action: () => {
          self.actionMenuOpen = false;
          showActivityTab();
        },
      });

      return actions;
    }

    function refreshActivity() {
      $rootScope.$broadcast("activity:refresh");
    }

    /**
     * Populate's self.room, self.level, and self.asset from the work order.
     * @return { Promise<void> }
     */
    function populateLocationData() {
      self.assets = WorkOrderService.getAssets(self.workOrder);
      self.rooms = WorkOrderService.getRooms(self.workOrder);
      self.levels = WorkOrderService.getLevels(self.workOrder);

      // populate self.locations for editing locations
      self.locations = self.workOrder.round;
      // populate the locations
      for (var i = 0; i < self.locations.length; i++) {
        var location = self.locations[i];
        if (location.asset) {
          location.room = location.asset.room || null;
          location.floor = location.asset.level || null;
        } else if (location.room) {
          location.asset = null;
          location.floor = location.room.level || null;
        } else if (location.level) {
          location.asset = null;
          location.room = null;
          location.floor = location.level;
        }
        self.locations[i] = angular.copy(location);
      }
      // save ref to original locations in case they are changed
      self.originalLocations = angular.copy(self.locations);
      if (self.rooms.length === 1) {
        return parseRoomDisplayValue(self.rooms[0]);
      }
      return $q.resolve();
    }

    function parseRoomDisplayValue(room) {
      if (!room) {
        self.roomDisplayName = null;
        return $q.resolve();
      }
      return ServiceHelpers.getRoomDisplayName(room)
        .then(function (displayName) {
          self.roomDisplayName = displayName || room.name;
        })
        .catch(function (err) {
          self.roomDisplayName = room.name;
          ToastService.showError;
        });
    }

    // ------------------------
    //   Public Functions
    // ------------------------
    function showActivityTab() {
      self.activeTab = 1;
      self.isOpen = true;
    }

    function showDetailsTab() {
      self.activeTab = 0;
      self.isOpen = true;
    }

    function toggleActionMenu() {
      self.actionMenuOpen = !self.actionMenuOpen;
    }

    /**
     * Retrieve class for work order status (warn, success, etc.)
     *
     * @return {String}     Class name
     */
    function getStatusClass() {
      switch (self.workOrder.status_display) {
        case "Overdue":
          return "fg-warn";
        case "Open":
          return "fg-success";
        default:
          return "fg-white";
      }
    }

    /**
     * Navigate to building list
     */
    function goToBuilding() {
      $state.go("app.building.detail", {
        q: self.building._id,
      });
    }

    function goToState(type, entityId) {
      var params = { buildingId: self.building._id };
      var state = "";

      if (type === "asset") {
        if (entityId) {
          state = "app.building.asset.detail";
          params.assetId = entityId;
        } else {
          var asset = WorkOrderService.getAsset(self.workOrder);
          if (asset) {
            state = "app.building.asset.detail";
            params.assetId = asset._id;
          }
        }
      } else if (type === "room") {
        if (entityId) {
          state = "app.building.room.detail";
          params.roomId = entityId;
        } else {
          var room = WorkOrderService.getRoom(self.workOrder);
          if (room) {
            state = "app.building.room.detail";
            params.roomId = room._id;
          }
        }
      } else {
        return;
      }

      $state.go(state, params);
    }

    /**
     * Brings up dialog to add a work order log
     */
    function logWork() {
      WorkOrderLogDialog.show({
        locals: {
          workOrders: [self.workOrder],
        },
      }).then(function () {
        // update the UI to show changes to the WO Log
        refreshActivity();

        // Refresh activity event does not update the WO totals
        // in the detail page
        calculateWoLogTotals();
      });
    }

    /**
     * Navigate to work order cancel state
     */
    function cancel() {
      CancelWorkOrderDialog.show({
        locals: {
          workOrders: [
            { _id: self.workOrder._id, building: self.building._id },
          ],
        },
      }).then(function () {
        $state.go("app.building.workOrder.detail", actionStateParams, {
          reload: true,
        });
      });
    }

    /**
     * Navigate to work order complete state
     */
    function complete() {
      CompleteWorkOrderDialog.show({
        locals: {
          workOrders: [self.workOrder],
        },
      }).then(function () {
        // update the UI to show changes to the WO Log
        $state.go("app.building.workOrder.detail", actionStateParams, {
          reload: true,
        });
      });
    }

    /**
     * Navigate to work order reopen state
     */
    function reopen() {
      ReopenWorkOrderDialog.show({
        locals: {
          workOrders: [
            { _id: self.workOrder._id, building: self.building._id },
          ],
        },
      }).then(function () {
        // update the UI to show changes to the WO Log
        $state.go("app.building.workOrder.detail", actionStateParams, {
          reload: true,
        });
      });
    }

    function remove() {
      DeleteWorkOrderDialog.show({
        locals: {
          workOrders: [
            { _id: self.workOrder._id, building: self.building._id },
          ],
        },
      }).then(function () {
        $state.go(
          "app.building.workOrders",
          {
            buildingId: building._id,
          },
          {
            reload: true,
          }
        );
      });
    }

    function createNote(noteText, sendToRequester) {
      if (!noteText || !noteText.length) return;
      var data = {
        task: self.workOrder._id,
        building: self.building._id,
        text: noteText,
        is_public: sendToRequester,
      };

      if (sendToRequester) {
        data.emailRequester = true;
      }
      if (self.workOrder.request) {
        data.request = self.workOrder.request._id || self.workOrder.request;
      }

      NoteService.create(self.building._id, data)
        .then(function (note) {
          refreshActivity();

          if (sendToRequester) {
            ShadowService.sendEvent("workorder-activity", "send-existing-note");
          }
        })
        .catch(ToastService.showError);
    }

    function handleAddLocationClick() {
      self.locations.push({
        floor: null,
        room: null,
        asset: null,
      });
    }

    function handleRemoveLocationClick(location) {
      // save a reference to the original locations in case a user hits cancel before saving
      self.originalLocations = angular.copy(self.locations);
      if (self.locations.length > 1) {
        var indexToRemove = self.locations.indexOf(location);
        self.locations.splice(indexToRemove, 1);
      } else {
        self.locations = [{}];
      }
    }

    /**
     * Save the work order (except assignee)
     *
     * @return {Promise}
     */
    function save() {
      // map self.locations back to the workOrder round
      // format dates to send correctly to database without affecting self.workOrder (self.workOrder dates must
      // remain as Dates in order to avoid errors from md-datepicker)
      var tempWorkOrder = angular.copy(self.workOrder);
      tempWorkOrder.start_date = tempWorkOrder.start_date.getTime();
      tempWorkOrder.due_date = tempWorkOrder.due_date.getTime();

      if (!angular.isEmpty(tempWorkOrder.completed_date)) {
        tempWorkOrder.completed_date = new Date(
          tempWorkOrder.completed_date
        ).getTime();
      }

      // send only the ids instead of the whole objects
      var tempRound = [];
      if (self.multiLocationEnabled) {
        for (var i = 0; i < self.locations.length; i++) {
          var location = self.locations[i];
          if (location.asset) tempRound.push({ asset: location.asset._id });
          else if (location.room) tempRound.push({ room: location.room._id });
          else if (location.floor)
            tempRound.push({ level: location.floor._id });
        }
      } else {
        if (self.asset) {
          tempRound.push({ asset: self.asset._id });
        } else if (self.room) {
          tempRound.push({ room: self.room._id });
        } else if (self.level) {
          tempRound.push({ level: self.level._id });
        }
      }

      var updateRequests = [];

      // location update also need to be separate from other upates now
      delete tempWorkOrder.round;
      updateRequests.push(
        WorkOrderService.setRound(self.building._id, self.workOrder._id, {
          round: tempRound,
        })
      );

      if (self.type && self.type.intent === INTENT_ISSUE_TYPE) {
        tempWorkOrder.issue_type = self.type._id;
        tempWorkOrder.maintenance_type = null;
      } else if (self.type && self.type.intent === INTENT_MAINTENANCE_TYPE) {
        tempWorkOrder.maintenance_type = self.type._id;
        tempWorkOrder.issue_type = null;
      } else if (self.type === null) {
        tempWorkOrder.issue_type = null;
        tempWorkOrder.maintenance_type = null;
      }
      if (self.trade) {
        tempWorkOrder.trade = self.trade._id;
      } else {
        tempWorkOrder.trade = null;
      }
      tempWorkOrder.cre_account = tempWorkOrder.cre_account._id;

      // backend requires assignee be updated separately from the rest of the work order
      var assigneesParams = {
        assignee_users: tempWorkOrder.assignee_users,
      };
      var assigneesRequest = WorkOrderService.assign(
        self.building._id,
        self.workOrder._id,
        assigneesParams
      );

      updateRequests.push(assigneesRequest);

      var remainingRequest = WorkOrderService.update(
        self.building._id,
        self.workOrder._id,
        tempWorkOrder
      );
      updateRequests.push(remainingRequest);

      var updatedWorkOrder;
      return $q
        .all(updateRequests)
        .then(function (response) {
          // Grab the updated work order from the most recent request
          updatedWorkOrder = response[response.length - 1];
          updatedWorkOrder.assignee_users = response[1].assignee_users;
          updatedWorkOrder.round = response[0].round;
          self.workOrder = updatedWorkOrder;
        })
        .catch(function (err) {
          self.workOrder = angular.copy(self.originalWorkOrder);
          ToastService.showError(err);
        })
        .finally(function () {
          init();
        });
    }

    /**
     * Cancel by reverting an attribute's value to its original
     * @param properties {[]}
     */
    function onCancel(properties) {
      var ow = self.originalWorkOrder;
      if (!angular.isArray(properties)) {
        $log.error("properties was not of type Array");
        return;
      }

      for (var i = 0; i < properties.length; i++) {
        var property = properties[i];

        if (property === "trade") {
          self.trade = ow.trade;
          continue;
        }

        if (property === "type") {
          self.type = ow.issue_type ? ow.issue_type : ow.maintenance_type;
          continue;
        }

        if (property === "location") {
          self.locations = self.originalLocations;
          continue;
        }

        if (property === "asset") {
          self.asset = WorkOrderService.getAsset(ow);
          continue;
        }

        if (property === "room") {
          self.room = WorkOrderService.getRoom(ow);
          continue;
        }

        if (property === "level") {
          self.level = WorkOrderService.getLevel(ow);
          continue;
        }

        if (
          !Object.prototype.hasOwnProperty.call(self.workOrder, property) ||
          !Object.prototype.hasOwnProperty.call(ow, property)
        ) {
          if (
            property === "days_overdue" &&
            Object.prototype.hasOwnProperty.call(self.workOrder, property) &&
            !Object.prototype.hasOwnProperty.call(ow, property)
          ) {
            self.workOrder.days_overdue = undefined;
          }
          continue; // keep going this shit don't exist
        }

        self.workOrder[property] = ow[property];
      }
    }

    function updateDates() {
      var millisecondsInADay = 1000 * 60 * 60 * 24;
      // // calculate days until due
      self.workOrder.days_until_due = Math.ceil(
        (moment(self.workOrder.due_date) - moment.utc(Date.now())) /
          millisecondsInADay
      );

      if (self.workOrder.days_until_due >= 0 && self.workOrder.days_overdue) {
        self.workOrder.days_overdue = undefined;
      }
      if (self.workOrder.days_until_due < 0) {
        self.workOrder.days_overdue = Math.abs(self.workOrder.days_until_due);
      }

      self.workOrder.minDate = self.workOrder.start_date;
    }

    function isEditing() {
      return (
        self.editingAssign ||
        self.editingCategory ||
        self.editingAssignees ||
        self.editingDates ||
        self.editingDescription ||
        self.editingDetails ||
        self.editingLocation ||
        self.editingActualManHr ||
        self.editingCost ||
        self.editingMaterialUsed ||
        self.editingCompletedText
      );
    }

    /**
     * Navigate to service request
     */
    function goToServiceRequest() {
      $state.go("app.building.serviceRequest.detail", {
        buildingId: self.building._id,
        requestId: self.workOrder.request._id,
      });
    }

    function searchTypes(query) {
      self.typeQuery = query;
      var getTypes;
      if (
        self.building &&
        (self.building.show_issue_types || self.building.show_maintenance_types)
      ) {
        // Check if we already have all the types or
        // if there's an outstanding request for them
        if (collection.types) {
          return filterCollection(collection.types, self.typeQuery, "name");
        } else if (typeRequest) {
          return typeRequest;
        }

        // if from a service request, only get issue types
        if (self.showIssueTypes && !self.showMaintenanceTypes) {
          getTypes = IssueTypeService.getAll(self.building._id);
        } else if (self.showMaintenanceTypes && !self.showIssueTypes) {
          // if from a maintenance schedule, only get maintenance types
          getTypes = MaintenanceTypeService.getAll(self.building._id);
        } else {
          // if standalone, fetch all issue types and maintenance types
          getTypes = TypeService.getTypes(self.building);
        }

        typeRequest = getTypes
          .then(function (types) {
            collection.types = types;
            return filterCollection(collection.types, self.typeQuery, "name");
          })
          .catch(function (err) {
            ToastService.showError(err);
            collection.types = [];
            return $q.reject(err);
          });
        return typeRequest;
      }
      return [];
    }

    function searchTrades(query) {
      self.tradeQuery = query;
      if (self.building && self.building.show_trades) {
        // Check if we already have all the trades or
        // if there's an outstanding request for them
        if (collection.trades) {
          return filterCollection(collection.trades, self.tradeQuery, "name");
        } else if (tradeRequest) {
          return tradeRequest;
        }
        // Fetch all trades
        tradeRequest = TradeService.getAll(self.building._id)
          .then(function (trades) {
            collection.trades = trades;
            return filterCollection(collection.trades, self.tradeQuery, "name");
          })
          .catch(function (err) {
            ToastService.showError(err);
            collection.trades = [];
            return $q.reject(err);
          });
        return tradeRequest;
      }
      return [];
    }

    function onTypeChange(type) {
      if (self.typeFromInit) {
        self.typeFromInit = false;
        return;
      }

      if (self.trade) return;

      // Set default trade
      if (type && type.trade && self.building.show_trades) {
        self.loadingTrade = true;
        if (collection.trades) {
          for (var i = 0; i < collection.trades.length; ++i) {
            if (type.trade === collection.trades[i]._id) {
              self.trade = collection.trades[i];
              self.loadingTrade = false;
              return;
            }
          }
        }
        TradeService.getById(self.building._id, type.trade)
          .then(function (trade) {
            self.trade = trade;
          })
          .finally(function () {
            self.loadingTrade = false;
          });
      }
    }

    function getAssignees(workOrder) {
      UserService.getAll(self.organization._id, {
        _id: "$in," + workOrder.assignee_users.join(","),
      }).then(function (users) {
        self.assignees = users;
      });
    }

    function onAssigneesChange(event) {
      var newUserIds = event.value.map((u) => u._id);
      self.workOrder.assignee_users = newUserIds;
      // <abx-multiple-assignee /> inut requires a promise to be returned
      return $q.resolve();
    }

    /**
     * Filter a collection (list) with a search query
     *
     * @param  {Array}  collection  Collection of options
     * @param  {String} query       Search query text
     * @param  {String} key         [Optional] key to match on
     *
     * @return {Array}              Query matches
     */
    function filterCollection(collection, query, key) {
      if (angular.isEmpty(query)) return collection;
      var matchExp = new RegExp(query, "i");
      return collection.filter(function (item) {
        var value = key ? item[key] : item;
        return value.match(matchExp);
      });
    }

    /**
     * Get the total cost and total minutes worked from logs associated with this work order
     */
    function calculateWoLogTotals() {
      // Check if we have work orders to display the totals
      if (!self.workOrder) {
        // Keep return type the same
        return $q.resolve();
      }

      return $q
        .all([
          WorkOrderLogService.getStatsByTaskId(
            self.building._id,
            self.workOrder._id,
            {
              operator_field: "work_minutes",
              operator: "sum",
            }
          ),
          WorkOrderLogService.getStatsByTaskId(
            self.building._id,
            self.workOrder._id,
            {
              operator_field: "cost",
              operator: "sum",
            }
          ),
        ])
        .then(function (results) {
          var workMinutes = results[0][0].result;
          var cost = results[1][0].result;

          self.workOrderLogStats.totalLoggedMinutes = workMinutes;
          self.workOrderLogStats.totalCost = "$" + cost;
        })
        .catch(function (error) {
          ToastService.showError(new Error("Unable to get activity"));
          return $q.reject(error);
        });
    }
  }
})();
